import { render } from "./CopyButton.vue?vue&type=template&id=3b38902c&scoped=true"
import script from "./CopyButton.vue?vue&type=script&lang=js"
export * from "./CopyButton.vue?vue&type=script&lang=js"

import "./CopyButton.vue?vue&type=style&index=0&id=3b38902c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b38902c"]])

export default __exports__